import GoogleMapReact from "google-map-react"
import { useContext, useEffect, useRef, useState } from "react";
import Supercluster from 'supercluster';
import { extendedBounds, fetchMapPoints, filterPointsOutOfMap, GDouglasPeucker, mapSettings, haversineDistance, pointArrayLongFormat } from "./mapUtils";
import { FiltersDispatchContext, FiltersStateContext } from "shared-components/Contexts/Filters/context";
import { getOnlyValues } from "shared-components/Components/Filters/Filters.hook";
import { Marker } from "./Marker";
import { InfoWindow } from "./InfoWindow";
import { AskForDraw, DrawBtn } from "./Drawing";
import { MapLoader } from "./MapLoader";
import { gql, useLazyQuery } from "@apollo/client";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { useSearchResultsFilters } from "shared-components/ViewFragments/SearchResults/Sider/Filters/SearchResultsFilters.hook";

const QUERY_MAP_LOCATION = gql`
	query MapLocation($id: Int!, $type:LocationTypes!){
        location(id: $id, type:$type){
            __typename
            ...on Estate{
            id name polygon{latitude longitude}
            }
            
            ... on Neighborhood{
            id name polygon{latitude longitude}
            }
        }
    }
`;

export const calculateVisibleItems = (containerHeight) => {
    let itemsQty = 0;
    const totalItemHeight = 175 + 10;

    itemsQty = Math.floor(containerHeight / totalItemHeight);

    return itemsQty;
};

export const MapSearch = () => {
    const filters = useContext(FiltersStateContext)
    const { changeFiltersAndUpdateURL } = useSearchResultsFilters();
    const filtersChange = useContext(FiltersDispatchContext);
    const { country_code, main_domain } = useContext(ConfigStateContext);
    const screen = useWindowSize()
    const [getLocationPolygon] = useLazyQuery(QUERY_MAP_LOCATION)
    const [points, setPoints] = useState([])
    const [sortedPoints, setSortedPoints] = useState([])
    const [bounds, setBounds] = useState(null)
    const [zoom, setZoom] = useState(14)
    const [drawing, setDrawing] = useState(false)
    const [drawingModal, setDrawingModal] = useState(true)
    const [polygon, setPolygon] = useState(null)
    const [center, setCenter] = useState(mapSettings(country_code).dafaults.center)
    const MAP = useRef(null);
    const MAPS = useRef(null);
    const eventMap = typeof window !== "undefined" && "ontouchstart" in document.documentElement ? "touchstart" : "mousedown";
    const [loading, setLoading] = useState(false)
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [isCluster, setIsCluster] = useState(false);
    const [neighborhood_id, setNeighborhood_id] = useState(null)
    const [estate_id, setEstate_id] = useState(null)
    const [clickedMarkers, setClickedMarkers] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [carouselData, setCarouselData] = useState([]);
    const [visibleItems, setVisibleItems] = useState(0);

    useEffect(() => {
        if ((carouselData.length < visibleItems && sortedPoints.length > 0) && visibleItems > 0) {
            setCarouselData(sortedPoints.slice(0, visibleItems));
        }
    }, [sortedPoints, visibleItems]);

    const loadMoreData = () => {
        setCarouselData(prevData => [
            ...prevData,
            ...sortedPoints.slice(prevData.length, prevData.length + visibleItems)
        ]);
    };

    const handleVisibleIdChange = (lat, lng, id, index = null) => {
        let latOffset = centerMarkerLatOffset();
        setCenter({ lat: parseFloat(lat) - latOffset, lng: parseFloat(lng) });
        setSelectedMarker(id);
        if (index) setCurrentIndex(Number(index));

        if (!clickedMarkers.includes(id)) {
            setClickedMarkers(prev => [...prev, id]);
        }
        // setZoom(18);
    };

    useEffect(() => {
        fitMapToPoints()
    }, [points])

    useEffect(() => {
        if (polygon !== null && polygon.length === 1 && !polygon[0].length && !loading) {
            resetMapState()
        } else if (polygon && polygon.length > 0 && !loading) {
            setLoading(true)
            let map_bound = polygon;
            map_bound = GDouglasPeucker(map_bound, 50);
            map_bound.push(map_bound[0]);

            if (filters?.map_bounds == null && !filters?.neighborhood_id?.length && !filters?.estate_id) {
                resetMapState();
            } else {
                if (!filters?.neighborhood_id?.length && !filters?.estate_id) {
                    changeFiltersAndUpdateURL({
                        mapView: true,
                        map_bounds: { "text": "Dibujo en Mapa", "value": pointArrayLongFormat(map_bound) },
                        map_polygon: { "text": "Poligono", "value": pointArrayLongFormat(polygon) },
                    });
                }

                fetchMapPoints(getOnlyValues(filters), polygon, main_domain).then(p => {
                    if (p) {
                        setPoints(p)
                        setLoading(false)
                    }
                })
            }
        }
    }, [filters, polygon])

    useEffect(() => {
        if (filters?.neighborhood_id?.length > 0) {
            let hoodsIDs = filters?.neighborhood_id?.map(n => n.value)
            setLocationPoly(hoodsIDs, 'Neighborhood')
            setNeighborhood_id(hoodsIDs)
        } else if (filters?.estate_id) {
            setLocationPoly([filters?.estate_id?.value], 'Estate')
            setEstate_id(filters?.estate_id?.value)
        } else if (filters?.map_polygon) {
            setPolygon(filters?.map_polygon?.value.map(p => { return { lat: p.latitude, lng: p.longitude } }))
        }
        else if (estate_id || neighborhood_id) {
            resetMapState()
        }
    }, [filters])

    useEffect(() => {
        if (!MAP.current && !MAPS.current) return;
        MAPS.current.drawing = drawing
        MAP.current.setOptions({
            clickableIcons: false,
            draggable: !drawing,
            draggableCursor: drawing ? "crosshair" : "grab",
            zoomControl: !drawing && (screen.lg || screen.xl || screen.xxl),
            scrollwheel: !drawing,
            disableDoubleClickZoom: drawing,
        });
    }, [drawing])

    useEffect(() => {
        updatePolygon()
    }, [polygon])

    useEffect(() => {
        const calculateAndSetVisibleItems = () => {
            const container = document.querySelector('.overlay-wrapper__container');

            if (container) {
                const containerHeight = container.getBoundingClientRect().height;
                const visible = calculateVisibleItems(containerHeight);

                setVisibleItems(visible + 3);
            }
        };

        calculateAndSetVisibleItems();

        const observer = new MutationObserver(() => {
            calculateAndSetVisibleItems();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, [screen.viewportHeight, selectedMarker]);

    const fitMapToPoints = () => {
        if (MAPS.current && !!points?.length) {
            let bounds = new MAPS.current.LatLngBounds()
            points?.forEach(e => bounds.extend({ lat: parseFloat(e.lat), lng: parseFloat(e.long) }))
            MAP.current.fitBounds(bounds)
        }
    }

    const setLocationPoly = async (hoodsIDs, type: 'Estate' | 'Neighborhood') => {
        let mergedPolygon = []
        for (let i = 0; i < hoodsIDs.length; i++) {
            let id = hoodsIDs[i]
            let { data: { location } } = await getLocationPolygon({ variables: { id: id, type: type } })
            let hoodPolygon = location?.polygon?.map(p => { return { lat: p.latitude, lng: p.longitude } })
            mergedPolygon = [...mergedPolygon, hoodPolygon]
        }

        setPolygon(mergedPolygon)
    }

    const genClusters = () => {
        if (!polygon || polygon.length <= 0) return [];

        const extBounds = extendedBounds(bounds);
        let geoPoints = points;

        geoPoints = filterPointsOutOfMap(points, extBounds);
        geoPoints = geoPoints?.map(p => ({
            "type": "Feature",
            "properties": {
                "propID": p.id,
                ...p
            },
            "geometry": {
                "type": "Point",
                "coordinates": [parseFloat(p.lat), parseFloat(p.long)]
            }
        }));


        const index = new Supercluster({ radius: 60, extent: 200, maxZoom: 20 });
        index.load(geoPoints);
        const clusters = index.getClusters([-180, -85, 180, 85], zoom);

        const clustersWithPoints = clusters.map(cluster => {
            if (cluster.properties.cluster) {
                const clusterId = cluster.id;
                const clusteredPoints = index.getLeaves(clusterId, Infinity).sort((a, b) => a.properties.propID - b.properties.propID);
                cluster.properties.pointsData = clusteredPoints.map(point => point.properties);
                cluster.properties.randomID = btoa(JSON.stringify(cluster.properties.pointsData))
            }
            return cluster;
        });

        return clustersWithPoints;
    }

    const updatePolygon = () => {
        if (!MAP.current && !MAPS.current) return;

        if (MAPS.current.savedPolygon !== null) {
            MAPS.current.savedPolygon.setMap(null);
        }
        if (!polygon || polygon.length === 0) return;

        MAPS.current.savedPolygon = new MAPS.current.Polygon({
            paths: polygon,
            strokeColor: '#35394e',
            strokeOpacity: 1,
            strokeWeight: 2,
            fillColor: '#A1ACE8',
            fillOpacity: 0.1,
            clickable: false,
            map: MAP.current,
            geodesic: true,
        });
    }

    const apllyDraw = (polyPoints) => {
        setDrawing(false)
        setPolygon(polyPoints)
        filtersChange({
            type: "merge",
            payload: { neighborhood_id: [], estate_id: null },
            country_code: country_code,
        })
    }

    const handleApiLoaded = (__map, __maps) => {
        MAP.current = __map;
        MAPS.current = __maps;
        MAPS.current.drawing = drawing;
        MAPS.current.drawingPolygon = null;
        // MAPS.current.drawingPolygonLine = null;
        MAPS.current.savedPolygon = null;

        MAPS.current.event.addDomListener(MAP.current.getDiv(), eventMap, function (e) {
            e.preventDefault();
            if (MAPS.current.drawing) {
                if (MAPS.current.drawingPolygon) {
                    MAPS.current.drawingPolygon.setMap(null);
                    // MAPS.current.drawingPolygonLine.setMap(null);
                }

                let lineSettings = {
                    map: MAP.current,
                    clickable: false,
                    strokeColor: "#35394e",
                    strokeOpacity: 1,
                    strokeWeight: 2,
                    fillOpacity: 0,
                    geodesic: true,
                };

                MAPS.current.drawingPolygon = new MAPS.current.Polyline(lineSettings)
                // MAPS.current.drawingPolygonLine = new MAPS.current.Polyline(lineSettings);
            }
        });

        MAPS.current.event.addListener(MAP.current, "mousemove", function (e) {
            // e.preventDefault();
            if (MAPS.current.drawing && MAPS.current.drawingPolygon) {
                let mainPath = MAPS.current.drawingPolygon.getPath()
                // MAPS.current.drawingPolygonLine.setPath([mainPath.getAt(0), e.latLng])
                mainPath.push(e.latLng);
            }
        });

        MAPS.current.event.addListener(MAP.current, "mouseup", function (e) {
            // e.preventDefault();
            if (MAPS.current.drawing) {
                let polyPoints = MAPS.current.drawingPolygon
                    .getPath()
                    .getArray()
                    .map(o => {
                        return {
                            lat: o.lat(),
                            lng: o.lng(),
                        };
                    })

                apllyDraw(polyPoints)
                MAPS.current.drawingPolygon.setMap(null);
                // MAPS.current.drawingPolygonLine.setMap(null);
            }
        });

        updatePolygon();
    }

    const toggleDrawing = () => {
        let newVal = !drawing
        /**
         este if no se sabe porque se puso. Se comentó porque generaba un bug, pero capaz al comentarlo se esta reviviendo otro bug viejo
         */
        // if (newVal) {
        resetMapState()
        changeFiltersAndUpdateURL({
            map_bounds: { "text": "Dibujo en Mapa", "value": [-1] },
        });
        // }
        setDrawing(newVal)
    }

    const resetMapState = (val = true) => {
        setSelectedMarker(null)
        if (val) {
            setDrawingModal(true)
        } else {
            setDrawingModal(false)
        }
        setPolygon(null)
        setPoints([])
        setEstate_id(null)
        setNeighborhood_id(null)
        setLoading(false)
        setClickedMarkers([])
        changeFiltersAndUpdateURL({
            map_bounds: null,
            map_polygon: null,
            neighborhood_id: [],
            estate_id: null,
        });
        setCurrentIndex(0)
        setCarouselData([])
    }

    const centerMarkerLatOffset = () => {
        if (screen.lg || !MAP?.current) return 0

        let offset = 0
        const bounds = MAP?.current?.getBounds();
        const north = bounds?.getNorthEast().lat();
        const south = bounds?.getSouthWest().lat();
        if (north && south) {
            offset = (north - south) / 4
        }
        return offset
    }

    const _onChildClick = (key, childProps) => {
        setCurrentIndex(0)

        let latOffset = centerMarkerLatOffset()

        if (childProps?.pointObj?.properties?.cluster) {
            const clusterId = childProps.pointObj.properties.randomID;
            const clusteredPoints = childProps.pointObj.properties.pointsData || [];

            let newZoom = zoom >= 18 ? 18 : zoom + 1;
            if (newZoom < 14) newZoom = 14;
            setZoom(newZoom);

            if (zoom == 16) {
                setSelectedMarker(clusterId);
                setIsCluster(true)
                setCurrentIndex(0)
                if (!clickedMarkers.includes(clusterId)) {
                    setClickedMarkers(prev => [...prev, clusterId]);
                }
            } else {
                latOffset = 0
            }

            setCenter({ lat: parseFloat(childProps?.lat) - latOffset, lng: parseFloat(childProps?.lng) });

        } else {
            setIsCluster(false)
            setCenter({ lat: parseFloat(childProps?.lat) - latOffset, lng: parseFloat(childProps?.lng) });
            const markerID = childProps?.pointObj?.properties?.propID;
            setSelectedMarker(markerID);

            if (!clickedMarkers.includes(markerID)) {
                setClickedMarkers(prev => [...prev, markerID]);
            }
        }

        const sortedPoints = points
            .map(point => {
                return ({
                    ...point,
                    distance: haversineDistance(childProps?.lat, childProps?.lng, point.lat, point.long)
                })
            })
            .sort((a, b) => a.distance - b.distance);

        setCarouselData([])
        setSortedPoints(sortedPoints)

    };

    const nextPreviousCallback = (type, index = null) => {
        const isNext = type === "next";
        const newIndex = currentIndex + (isNext ? 1 : -1);
        const settedIndex = index ?? newIndex;

        const { id, lat, long } = carouselData[settedIndex];
        handleVisibleIdChange(lat, long, id);

        if (isNext && (carouselData.length - currentIndex) <= visibleItems) {
            loadMoreData();
        }

        setCurrentIndex(settedIndex);
    };

    const paginatorInfo =
    {
        "firstItem": 0,
        "lastItem": 0,
        "lastPage": 0,
        "total": points?.length ?? 0,
        "currentPage": 0
    }

    return <>
        <div className="mapContainer" >
            <MapLoader active={loading} />

            {drawingModal && !drawing && (!polygon || polygon.length <= 0) &&
                !filters?.neighborhood_id?.length && !filters?.estate_id?.value &&
                <AskForDraw close={() => { setDrawingModal(false) }} />
            }

            <InfoWindow
                selectedMarker={selectedMarker}
                closeCallback={() => setSelectedMarker(null)}
                isCluster={isCluster}
                nextPreviousCallback={(type, index) => nextPreviousCallback(type, index)}
                currentIndex={currentIndex}
                carouselData={carouselData}
                loadMoreData={loadMoreData}
                onVisibleIdChange={handleVisibleIdChange}
                paginatorInfo={paginatorInfo}
            />

            <GoogleMapReact
                bootstrapURLKeys={{ key: mapSettings(country_code).googleMapsApiKey }}
                defaultCenter={mapSettings(country_code).dafaults.center}
                defaultZoom={mapSettings(country_code).dafaults.zoom}
                options={{ ...mapSettings(country_code).options, zoomControl: (screen.lg || screen.xl || screen.xxl), clickableIcons: false }}
                center={center}
                zoom={zoom}
                onChildClick={_onChildClick}
                onChange={({ center, zoom, bounds }) => {
                    setBounds(bounds)
                    setZoom(zoom)

                }}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={x => handleApiLoaded(x.map, x.maps)}

            >
                {!loading && genClusters()?.map((p, i) =>
                    <Marker key={`marker-${i}`}
                        pointObj={p}
                        lat={p.geometry.coordinates[0]}
                        lng={p.geometry.coordinates[1]}
                        clickedMarkers={clickedMarkers}
                        selectedMarker={selectedMarker}
                    />
                )}
            </GoogleMapReact>
            {(screen.lg || !screen.lg && !selectedMarker) &&
                <DrawBtn drawing={drawing} polygon={polygon} action={toggleDrawing} actionClearMap={() => resetMapState(false)} />
            }

        </div>
        <style jsx global>{`
             html, body {
                overscroll-behavior: none;
            }
        `}</style>
    </>

}